import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const centerConfig = { transform(props) {
  const { inline, ...rest } = props;
  return {
    display: inline ? "inline-flex" : "flex",
    alignItems: "center",
    justifyContent: "center",
    ...rest
  };
} }

export function centerRaw(styles) {
  const s = getPatternStyles(centerConfig, styles || {})
  return centerConfig.transform(s, patternFns)
}

export const center = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function center(styles = {}) {
  return css(centerRaw(styles))
}), { raw: centerRaw, propKeys: ["inline"] })